const en_master_price_tier = {

}

export default en_master_price_tier;